<template>
<v-main class="pa-5 pb-4">
  <v-flex>
    <v-card class="rounded-xl">
      <v-card-title>
        <v-toolbar-title>
          Lista de Vídeos
        </v-toolbar-title>
        <v-spacer />
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details />
        </v-card-title>
      <v-data-table :headers="headers" no-data-text="Nenhum item disponível" :items="listaVideos" :search="search">
        <template v-slot:items="props">
          <td class="title">
            {{ props.item.nome }}
          </td>
          <td class="title">
            {{ props.item.link }}
          </td>
          <!-- <td class="text-xs-right">{{ props.item.idUnidade }}</td> -->
          <!--
          <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab small v-on="on">
                  <v-icon color="success" small @click="alterarVideo(props.item)">
                    edit
                  </v-icon>
                </v-btn>
              </template>
              <span>Alterar nome </span>
            </v-tooltip>
          </td> -->
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="alterarVideo(item)"
            >
              mdi-pencil
            </v-icon>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            sua busca por "{{ search }}" não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>

  <v-layout style="height: 90px; position: relative" right bottom>
    <v-btn id="mybutton" top-of="footer" right fab dark color="teal darken-4" :to="{path:'/cadastrarVideo'}" @click="">
      <v-icon dark>
        add
      </v-icon>
    </v-btn>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'

export default {
  name: 'ListaAdministrador',
  components: {
    // HelloWorld
  },
  data () {
    return {
      page: 1,
      search: '',
      isEditing: true,
      headers: [{
        text: 'Nome',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'ID',
        align: 'center',
        sortable: true,
        value: 'link'
      },
      // { text: 'unidade Administrada', value: 'id' },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false
      }

        // { text: 'Carbs (g)', value: 'carbs' },
        // { text: 'Protein (g)', value: 'protein' },
        // { text: 'Iron (%)', value: 'iron' }
      ],
      listaVideos: [],
      user: null,
      items: [{
        nomeLocal: 'aaa!',
        idLocal: '1'
      },
      {
        nomeLocal: 'bbb',
        idLocal: '3'
      },
      {
        nomeLocal: 'ccc',
        idLocal: '2'
      },
      {
        nomeLocal: 'ddd',
        idLocal: '15'
      },
      {
        nomeLocal: 'eee',
        idLocal: '31'
      },
      {
        nomeLocal: 'fff',
        idLocal: '22'
      }
      ]
    }
  },
  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    if (this.user.tipo != 10) {
      this.$router.push('/login')
      return
    }
    // console.log(this.user);
    this.retornarVideos()
  },
  created () {
    console.log('created...')
  },
  methods: {

    alterarVideo (item) {
      this.$router.push({
        name: 'alterarVideo',
        params: {
          item: item
        }
      })
    },

    retornarVideos (item) {
      console.log('em editar local...')
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .retornarVideos()
        .then(rsp => {
          console.log('rsp oi:')
          this.listaVideos = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }

  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
